@if (direction.Road.length) {
  <span class="route-signposts">
    @switch (direction.Type) {
      @case (1) {
        <aa-motorway-signpost [road]="direction.Road"></aa-motorway-signpost>
      }
      @case (2) {
        <aa-primary-road-signpost [road]="direction.Road"></aa-primary-road-signpost>
      }
      @case (3) {
        <aa-local-road-signpost [road]="direction.Road"></aa-local-road-signpost>
      }
      @case (4) {
        <aa-place-of-interest-signpost [road]="direction.Road"></aa-place-of-interest-signpost>
      }
      @case (5) {
        <aa-signpost [road]="direction.Road"></aa-signpost>
      }
      @case (6) {
        <aa-raf-base-signpost [road]="direction.Road"></aa-raf-base-signpost>
      }
      @case (7) {
        <aa-hospital-signpost [road]="direction.Road"></aa-hospital-signpost>
      }
    }
  </span>
}